import { BOAT_RACE_IMAGES } from './boatRacePostUtils';

const GALLERY_IMAGES = {
  heats: BOAT_RACE_IMAGES.heats,
  alleppey: BOAT_RACE_IMAGES.alleppey,
  aranmula: BOAT_RACE_IMAGES.aranmula,
};

/** അപ്പർ കുട്ടനാട് ജലോത്സവം 2026 — സമയം, വള്ളങ്ങൾ, ടീമുകൾ & ലൈവ് (മലയാളം) */
export const UPPER_KUTTANAD_VALLAM_KALI_MALAYALAM_POST = {
  id: 'featured-upper-kuttanad-vallam-kali-malayalam',
  slug: 'upper-kuttanad-vallam-kali-2026-timing-boats-live-stream-malayalam',
  title: 'അപ്പർ കുട്ടനാട് വള്ളംകളി 2026: സമയം, വള്ളങ്ങൾ, ടീമുകൾ & ലൈവ് സ്ട്രീം',
  excerpt:
    'നാലാമത് അപ്പർ കുട്ടനാട് ജലോത്സവം 2026 ഓഗസ്റ്റ് 25-ന് — ഉച്ചയ്ക്ക് 2.30-ന് പമ്പയാറ്റിൽ, 1,200 മീറ്റർ ട്രാക്ക്, ചുണ്ടൻ-വെപ്പ് പട്ടിക, പ്രവാസികൾക്ക് സൗജന്യ YouTube ലൈവ് ലിങ്കുകൾ.',
  publishedAt: '2026-08-23T10:00:00.000Z',
  coverImageUrl: BOAT_RACE_IMAGES.aranmula,
  authorName: 'Daily Sports Life',
  clubName: 'കേരള കായിക വാർത്താ ഡെസ്ക്',
  audience: 'മലയാളി പ്രേക്ഷകർ',
  blogCategory: 'boat-races',
  locale: 'ml',
  boatRaceTopic: 'upper-kuttanad-2026',
  alternateSlug: 'upper-kuttanad-vallam-kali-2026-timing-boats-live-stream',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'ബന്ധപ്പെട്ട വള്ളംകളി ലേഖനങ്ങൾ',
  relatedPosts: [
    {
      slug: 'upper-kuttanad-vallam-kali-2026-timing-boats-live-stream',
      title: 'Upper Kuttanad Vallam Kali 2026: Timing, Boats & Live Stream (English)',
      blurb: 'ഇംഗ്ലീഷ് പതിപ്പ്.',
    },
    {
      slug: 'nehru-trophy-2026-chundan-vallam-malayalam',
      title: '72-ാം നെഹ്‌റു ട്രോഫി 2026: 22 ചുണ്ടൻ വള്ളങ്ങൾ, ക്ലബുകൾ, കാപ്റ്റൻമാർ',
      blurb: 'പുന്നമടയിലെ പൂർണ്ണ ചുണ്ടൻ പട്ടിക.',
    },
    {
      slug: 'kerala-boat-race-live-stream-youtube-malayalam',
      title: 'കേരള വള്ളംകളി ലൈവ്: സൗജന്യ YouTube ചാനലുകൾ',
      blurb: 'എല്ലാ പ്രധാന മലയാളം ന്യൂസ് ഡെസ്കുകളും.',
    },
    {
      slug: 'thalavady-chundan-charithram-ntbr-cbl-2026-malayalam',
      title: 'തലവടി ചുണ്ടൻ: ചരിത്രം, വിജയങ്ങൾ & NTBR / CBL 2026',
      blurb: 'കുതിരത്തല ചുണ്ടൻ — ജലോത്സവത്തിൽ പ്രതീക്ഷിക്കാവുന്ന പങ്കാളി.',
    },
  ],
  referenceLinks: [
    {
      label: 'Reporter Live — നാലാമത് അപ്പർ കുട്ടനാട് ജലോത്സവം',
      url: 'https://www.reporterlive.com/district-news/pathanamthitta/2026/07/16/fourth-upper-kuttanad-water-festival-august-25',
    },
    {
      label: 'മാധ്യമം — അപ്പർ കുട്ടനാട് ചുണ്ടൻ വള്ളങ്ങൾ',
      url: 'https://www.madhyamam.com/kerala/boats-from-upper-kuttanad-which-participates-nehru-trophy-boat-race-1442442',
    },
    {
      label: 'കേരള ടൂറിസം — വീയപുരം ചുണ്ടൻ',
      url: 'https://www.keralatourism.org/champions-boat-league/snake-boats/veeyapuram-chundan',
    },
    {
      label: 'കേരള ടൂറിസം — വള്ളംകളി കലണ്ടർ',
      url: 'https://www.keralatourism.org/event/boat-races/',
    },
    {
      label: 'ചാമ്പ്യൻസ് ബോട്ട് ലീഗ്',
      url: 'https://www.keralatourism.org/champions-boat-league/',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'അപ്പർ കുട്ടനാട് വള്ളംകളി 2026 — സംക്ഷിപ്തം',
      items: [
        { value: '25 ഓഗ 2026', label: 'നാലാമത് അപ്പർ കുട്ടനാട് ജലോത്സവം' },
        { value: 'ഉച്ച 2.30', label: 'വള്ളംകളി ആരംഭം (IST)' },
        { value: '1,200 മീ', label: 'പമ്പയാർ ട്രാക്ക്' },
        { value: '25+', label: 'പ്രതീക്ഷിക്കുന്ന വള്ളങ്ങൾ' },
      ],
    },
    {
      type: 'panel',
      title: 'ചുണ്ടന്മാരുടെ തലസ്ഥാനം — പമ്പയാറ്റിലെ ഓളപ്പരപ്പ്',
      paragraphs: [
        '**72-ാം നെഹ്‌റു ട്രോഫി** കഴിഞ്ഞ് മൂന്ന് ദിവസത്തിന് ശേഷം കേരളത്തിന്റെ വള്ളംകളി കലണ്ടർ **പമ്പയാർ** വഴി മുകളോട്ട് നീങ്ങുന്നു. **നാലാമത് അപ്പർ കുട്ടനാട് ജലോത്സവം** **2026 ഓഗസ്റ്റ് 25-ന്** — **ഉത്രാടം**, ഓണത്തിന്റെ മുൻദിനം — **വീയപുരം, നിരണം, കടപ്ര, മാന്നാർ** പഞ്ചായത്തുകളിൽ ആഘോഷമാകുന്നു.',
        '**അപ്പർ കുട്ടനാട് ബോട്ട് ക്ലബ് (UKBC)** നേതൃത്വത്തിൽ നടക്കുന്ന ഈ ജലോത്സവം **കടപ്ര ബേത്ലഹേം സെന്റ് ജോർജ് ഓർത്തഡോക്സ് പള്ളിക്കടവ്** മുതൽ **കടപ്ര സെന്റ് തോമസ് ഹൈസ്കൂൾ കടവ്** വരെ **1,200 മീറ്റർ** നീളമുള്ള ഡിജിറ്റൽ സർവേ ചെയ്ത നെട്ടായത്തിൽ നടക്കും. കേരളത്തിന്റെ പ്രമുഖ വള്ളങ്ങൾക്കൊപ്പം പ്രാദേശിക വള്ളങ്ങളും **ചുണ്ടൻ, വെപ്പ്, ഇരുട്ടുകുത്തി, ചുരുളൻ** വിഭാഗങ്ങളിൽ മത്സരിക്കും.',
        'വീയപുരം പഞ്ചായത്തിൽ മാത്രം **എട്ട് ചുണ്ടൻ വള്ളങ്ങൾ** — അതുകൊണ്ട് **«ചുണ്ടന്മാരുടെ തലസ്ഥാനം»**. നെഹ്‌റു ട്രോഫിയിൽ 22 ചുണ്ടൻ വള്ളങ്ങളിൽ **12-ഉം** അപ്പർ കുട്ടനാട്ടിൽ നിന്നാണ്. ഈ ജലോത്സവം CBL സീസണിന് മുമ്പുള്ള കരുത്ത് പരീക്ഷണമാണ്.',
      ],
      chips: ['അപ്പർ കുട്ടനാട്', 'പമ്പയാർ', 'ഉത്രാടം 2026', 'UKBC', 'വള്ളംകളി'],
    },
    {
      type: 'imageGallery',
      title: 'കുട്ടനാട് വള്ളംകളി — ചിത്രങ്ങൾ',
      intro: 'കേരള ജലമേളകളിലെ രംഗങ്ങൾ — Wikimedia Commons (CC BY-SA).',
      images: [
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'കേരള ചുണ്ടൻ വള്ളങ്ങൾ',
          caption: 'ചുണ്ടൻ വള്ളങ്ങൾ — Anoopkn / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'ആലപ്പുഴ വള്ളംകളി',
          caption: 'പമ്പ–കുട്ടനാട് ജലനെറ്റ്‌വർക്കിലെ മത്സരം — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.heats,
          alt: 'നെഹ്‌റു ട്രോഫി ഹീറ്റ്സ്',
          caption: 'നൂറ് തുഴകളുടെ താളം — കുട്ടനാടിന്റെ ഹൃദയമിടിപ്പ്.',
        },
      ],
    },
    {
      type: 'table',
      title: 'മത്സര സമയക്രമം — 2026 ഓഗസ്റ്റ് 25 (IST)',
      intro:
        'ഔദ്യോഗിക ആരംഭം **ഉച്ചയ്ക്ക് 2.30**. ചെറുവള്ളങ്ങൾ ആദ്യം; ചുണ്ടൻ ഫൈനൽ ഉച്ചയ്ക്ക് ശേഷം. ജലനിരപ്പും കാറ്റും ക്രമം മാറ്റാം.',
      headers: ['സമയം (IST)', 'പരിപാടി', 'കുറിപ്പ്'],
      rows: [
        ['ഉച്ച 12.00 മുതൽ', 'കരയിലെ ഒരുക്കം & സാംസ്കാരിക വേദി', 'കടപ്ര കരയിൽ ഭക്ഷണസ്ഥലങ്ങൾ, ചെണ്ട, വഞ്ചിപ്പാട്ട്'],
        ['ഉച്ച 2.00', 'അതിഥി എത്തൽ', 'അപ്പർ കുട്ടനാട് വാട്ടർ സ്റ്റേഡിയത്തിൽ'],
        ['ഉച്ച 2.30', 'ഉദ്ഘാടന & പതാകയേറ്റം', 'ഡിജിറ്റൽ സ്റ്റിൽ സ്റ്റാർട്ടിംഗ് — 2026-ൽ പുതിയ സംവിധാനം'],
        ['2.45', 'ചുരുളൻ ഹീറ്റ്സ്', 'ഏറ്റവും ചെറിയ വിഭാഗം'],
        ['3.15', 'വെപ്പ് എ & വെപ്പ് ബി', 'പാരമ്പര്യ വെപ്പ് വള്ളങ്ങൾ'],
        ['3.45', 'ഇരുട്ടുകുത്തി ഹീറ്റ്സ്', 'ഏറ്റവും മത്സരബഹുലമായ ഉപ-ചുണ്ടൻ വിഭാഗം'],
        ['4.30', 'ചുണ്ടൻ ഹീറ്റ്സ് / ഫൈനൽ', 'പ്രധാന മത്സരം — NTBR/CBL ക്ലബുകൾ'],
        ['5.30 മുതൽ', 'സമ്മാനവിതരണം & സാംസ്കാരിക പരിപാടി', 'ഉത്രാടത്തിന്റെ സായാഹ്ന ആഘോഷം'],
      ],
    },
    {
      type: 'panel',
      title: 'സ്ഥലം & എത്തിച്ചേരൽ',
      orderedList: [
        '**ട്രാക്ക്:** കടപ്ര ബേത്ലഹേം പള്ളിക്കടവ് → സെന്റ് തോമസ് ഹൈസ്കൂൾ കടവ് (1,200 മീ)',
        '**വേദി:** അപ്പർ കുട്ടനാട് വാട്ടർ സ്റ്റേഡിയം, പമ്പയാർ (കടപ്ര, പത്തനംതിട്ട)',
        '**പഞ്ചായത്തുകൾ:** വീയപുരം, നിരണം, കടപ്ര, മാന്നാർ',
        '**അടുത്ത നഗരം:** തിരുവല്ല (~8 കി.മീ.) — റെയിൽവേ സ്റ്റേഷൻ',
        '**ആലപ്പുഴയിൽ നിന്ന്:** തിരുവല്ല വഴി ~45 കി.മീ.',
        '**പാർക്കിംഗ്:** ഉച്ചയ്ക്ക് 1.30-ന് മുമ്പ് എത്തുക — ഉത്രാട ദിവസം കര നിറയും',
      ],
      callout:
        '2026 പ്രത്യേകതകൾ: കൃത്യമായ സ്റ്റിൽ സ്റ്റാർട്ട്, ഡിജിറ്റൽ ട്രാക്ക്, വിദഗ്ധ വിധികർത്താക്കൾ, പ്രൊഫഷണൽ കമന്ററി (Reporter Live).',
    },
    {
      type: 'table',
      title: 'ചുണ്ടൻ വള്ളങ്ങൾ & ടീമുകൾ — 2026 പ്രതീക്ഷിക്കുന്ന പട്ടിക',
      intro:
        'കേരളത്തിന്റെ പ്രമുഖ ക്ലബുകളും പ്രാദേശിക വള്ളങ്ങളും മത്സരിക്കും. താഴെ **അപ്പർ കുട്ടനാട്ടിലെ** പ്രധാന ചുണ്ടൻ വള്ളങ്ങൾ — മത്സരദിവസം UKBC-യിൽ നിന്ന് ഫൈനൽ പട്ടിക സ്ഥിരീകരിക്കുക.',
      headers: ['#', 'ചുണ്ടൻ വള്ളം', 'ബോട്ട് ക്ലബ് / ടീം', 'ഗ്രാമം', 'കുറിപ്പ്'],
      rows: [
        ['1', 'വീയപുരം ചുണ്ടൻ', 'വില്ലേജ് ബോട്ട് ക്ലബ്, കൈനകരി', 'വീയപുരം', '2025 നെഹ്‌റു ട്രോഫി വിജയി; CBL സീസൺ 5 ചാമ്പ്യൻ'],
        ['2', 'കാരിച്ചാൽ ചുണ്ടൻ', 'കെ.സി.ബി.സി', 'കാരിച്ചാൽ', '16× നെഹ്‌റു ട്രോഫി റെക്കോർഡ്; 2024 വിജയി'],
        ['3', 'മേൽപ്പാടം ചുണ്ടൻ', 'പള്ളാത്തുരുത്തി ബോട്ട് ക്ലബ്', 'പള്ളാത്തുരുത്തി', 'പുന്നമട ഫൈനലിസ്റ്റ്'],
        ['4', 'തലവടി ചുണ്ടൻ', 'കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്', 'തലവടി', 'കുതിരത്തല — ആറാംതമ്പുരാൻ'],
        ['5', 'ചെറുതന ചുണ്ടൻ', 'തെക്കേക്കര ബോട്ട് ക്ലബ്', 'ചെറുതന', 'പായിപ്പാട് & കരുവാറ്റ വിജയങ്ങൾ'],
        ['6', 'കരുവറ്റ ചുണ്ടൻ', 'ജി.എൽ.സി / ബി.ബി.എം ബോട്ട് ക്ലബ്', 'കരുവാറ്റ', 'പായിപ്പാട് ജലോത്സവ പൈതൃകം'],
        ['7', 'കരുവറ്റ ശ്രീവിനായകൻ', 'മങ്കൊമ്പ് ബോട്ട് ക്ലബ്', 'കരുവാറ്റ', 'പ്രാദേശിക ട്രോഫി വിജയി'],
        ['8', 'വെള്ളംകുളങ്ങര ചുണ്ടൻ', 'എസ്.എച്ച് / സെന്റ് ജോസഫ് ബി.സി.', 'വെള്ളംകുളങ്ങര', 'കായൽപ്പുറം ചുണ്ടൻ'],
        ['9', 'പായിപ്പാടൻ 2 ചുണ്ടൻ', 'പായിപ്പാടൻ ബോട്ട് ക്ലബ്', 'പായിപ്പാട്', 'നീരാറ്റുപുറം വെള്ളിപാടം ജലോത്സവം'],
        ['10', 'ആനാരി ചുണ്ടൻ', 'കൈനകരി ടൗൺ ബോട്ട് ക്ലബ്', 'ആനാരി', '2021-ൽ പുനരാവതരിപ്പിച്ചു'],
        ['11', 'ആയാപറമ്പ് പാണ്ടി ചുണ്ടൻ', 'വലിയ ദിവാഞ്ചി ബി.സി.', 'ആയാപറമ്പ്', 'ദിവാഞ്ചി മത്സരങ്ങൾ'],
        ['12', 'ശ്രീകാർത്തികേയൻ ശ്രീ ഗണേഷ്', 'വീയപുരം പ്രാദേശിക ക്ലബ്', 'വീയപുരം', 'വീയപുരത്തിലെ എട്ട് ചുണ്ടനുകളിൽ ഒന്ന്'],
        ['13', 'പ്രാദേശിക ചുണ്ടൻ വള്ളങ്ങൾ', 'UKBC & ഗ്രാമ ക്ലബുകൾ', 'കടപ്ര / മാന്നാർ / നിരണം', 'മത്സരദിവസം പേരുകൾ സ്ഥിരീകരിക്കും'],
      ],
    },
    {
      type: 'table',
      title: 'മറ്റ് വിഭാഗങ്ങൾ — ടീമുകൾ',
      intro: 'രണ്ടാമത് ജലോത്സവത്തിൽ (2024) **25-ൽ പരം** വള്ളങ്ങൾ പങ്കെടുത്തു. 2026-ലും സമാനമായ പങ്കാളിത്തം പ്രതീക്ഷിക്കാം.',
      headers: ['വിഭാഗം', 'പ്രതീക്ഷിക്കുന്ന എണ്ണം', 'ഉദാഹരണ ടീമുകൾ'],
      rows: [
        ['ചുരുളൻ', '2–4', 'പ്രാദേശിക ഗ്രാമ ക്ലബുകൾ'],
        ['ഇരുട്ടുകുത്തി', '8–14', 'കടപ്ര, മാന്നാർ, നിരണം ഓഡി വള്ളങ്ങൾ'],
        ['വെപ്പ് എ', '4–6', 'വീയപുരം & കടപ്ര വെപ്പ് എൻട്രികൾ'],
        ['വെപ്പ് ബി', '3–5', 'രണ്ടാമത്തെ വെപ്പ് വിഭാഗം'],
        ['ചുണ്ടൻ', '8–12', 'മുകളിലെ പട്ടിക കാണുക'],
      ],
    },
    {
      type: 'panel',
      title: 'സംഘാടക സമിതി — അപ്പർ കുട്ടനാട് ബോട്ട് ക്ലബ്',
      paragraphs: [
        '**UKBC** 16 അംഗ സമിതിയോടെ ജലോത്സവം നടത്തിപ്പിക്കുന്നു. രണ്ടാമത് ജലോത്സവത്തിലെ (2024) നേതൃത്വം: **ജയിംസ് കുരുവിള** (പ്രസിഡന്റ്), **ലല്ലു കാട്ടിൽ** (സെക്രട്ടറി), **സൂസൻ ജോൺ** (ട്രഷറർ). നാലാമത് ജലോത്സവത്തിന് പുതിയ സമിതി പ്രഖ്യാപിക്കാം.',
        'സുതാര്യമായ വിധികർത്താക്കൾ, തുല്യ അവസരമുള്ള ട്രാക്കുകൾ, ഓണക്കാല സാംസ്കാരിക പരിപാടികൾ — UKBC-യുടെ ലക്ഷ്യം അപ്പർ കുട്ടനാടിന്റെ വള്ളംകളി പാരമ്പര്യം ജീവന്തമാക്കുക എന്നതാണ്.',
      ],
      chips: ['UKBC', 'ജയിംസ് കുരുവിള', 'കടപ്ര', 'സമൂഹ ക്ലബ്'],
    },
    {
      type: 'videoList',
      title: 'ലൈവ് സ്ട്രീമിംഗ് — YouTube-ൽ സൗജന്യം',
      intro:
        '**2026 ഓഗസ്റ്റ് 25, ഉച്ച 2.30 മുതൽ** താഴെയുള്ള ചാനലുകൾ തുറന്ന് **«അപ്പർ കുട്ടനാട് വള്ളംകളി ലൈവ്»** തിരയുക. **Reporter Live**-ൽ നിന്ന് തീയതി പ്രഖ്യാപിച്ചതിനാൽ അവിടെ നിന്ന് ലൈവ് സാധ്യത ഉയർന്നതാണ്.',
      videos: [
        {
          title: 'Reporter LIVE',
          channel: 'Reporter TV',
          description: 'നാലാമത് ജലോത്സവ തീയതി പ്രഖ്യാപിച്ച ചാനൽ — പത്തനംതിട്ട ജില്ലാ കവറേജ്.',
          url: 'https://www.youtube.com/@reporterlive',
        },
        {
          title: 'Asianet News Live',
          channel: 'Asianet News',
          description: 'വീയപുരം/കരുവാറ്റ മത്സരങ്ങൾ പതിവായി കവർ ചെയ്യുന്നു.',
          url: 'https://www.youtube.com/@asianetnews',
        },
        {
          title: 'Manorama News Live',
          channel: 'Manorama News',
          description: 'ഓണാഴ്ച വള്ളംകളി ലൈവ് & ഹൈലൈറ്റുകൾ.',
          url: 'https://www.youtube.com/@manoramanews',
        },
        {
          title: '24 News Live',
          channel: 'Twenty Four News',
          description: 'ഷൈജു ദാമോദരൻ / ഐപ്പി വള്ളിക്കടൻ കമന്ററി.',
          url: 'https://www.youtube.com/@24onlive',
        },
        {
          title: 'Mathrubhumi Live',
          channel: 'Mathrubhumi News',
          description: 'അപ്പർ കുട്ടനാട് & പമ്പയാർ റിപ്പോർട്ടിംഗ്.',
          url: 'https://www.youtube.com/@mathrubhuminewslive',
        },
        {
          title: 'MediaOne Live',
          channel: 'MediaOne',
          description: 'പ്രാദേശിക ജലോത്സവ കവറേജ്.',
          url: 'https://www.youtube.com/@MediaOneTVLive',
        },
        {
          title: 'Kairali News Live',
          channel: 'Kairali News',
          description: 'ഓണക്കാല വള്ളംകളി ലൈവ്.',
          url: 'https://www.youtube.com/@KairaliNews',
        },
        {
          title: 'Champions Boat League',
          channel: 'CBL — കേരള ടൂറിസം',
          description: 'ലീഗ് ഹൈലൈറ്റ് പാക്കേജുകൾ.',
          url: 'https://www.youtube.com/@ChampionsBoatLeague',
        },
      ],
    },
    {
      type: 'panel',
      title: 'പ്രവാസികൾക്കുള്ള ടിപ്പുകൾ',
      list: [
        '**സമയം:** ഉച്ച 2.30 IST = അമേരിക്ക കിഴക്കൻ തീരത്ത് രാവിലെ; UK-യിൽ ഉച്ച.',
        '**തിരയൽ:** «അപ്പർ കുട്ടനാട് ജലോത്സവം ലൈവ്», «കടപ്ര വള്ളംകളി», «UKBC vallamkali».',
        '**ബാക്കപ്പ്:** 2.45 വരെ ലൈവ് കാണാതെ വന്നാൽ Asianet/Manorama ഹൈലൈറ്റ് 2–3 മണിക്കൂറിനുള്ളിൽ.',
        '**YouTube:** സൗജന്യം — കേബിൾ ആവശ്യമില്ല.',
        '**വള്ളങ്ങൾ ഫോളോ ചെയ്യുക:** വീയപുരം, തലവടി ചുണ്ടൻ സോഷ്യൽ മീഡിയയിൽ അപ്ഡേറ്റ് നൽകും.',
      ],
      callout: {
        text: 'പൂർണ്ണ സ്ട്രീമിംഗ് ചാനൽ പട്ടിക →',
        url: '/blog/kerala-boat-race-live-stream-youtube-malayalam',
      },
    },
    {
      type: 'panel',
      title: 'ചുരുക്കത്തിൽ',
      paragraphs: [
        '**2026 ഓഗസ്റ്റ് 25, ഉച്ച 2.30** — **നാലാമത് അപ്പർ കുട്ടനാട് വള്ളംകളി** കടപ്രയിലെ **1,200 മീറ്റർ** പമ്പയാർ ട്രാക്കിൽ. **വീയപുരം, കാരിച്ചാൽ, മേൽപ്പാടം, തലവടി** തുടങ്ങിയ ജലരാജാക്കന്മാർ ഒരുമിക്കുന്നു.',
        'കരയിൽ എത്താൻ കഴിയുന്നില്ലെങ്കിൽ **Reporter Live**, **Asianet News**, **Manorama News** YouTube-ൽ ലൈവ് തിരയുക. **നല്ല തുഴച്ചിൽ, നല്ല താളം — ഉത്രാടാശംസകൾ!**',
      ],
      chips: ['അപ്പർ കുട്ടനാട് 2026', 'പമ്പയാർ', 'ഉത്രാടം', 'ലൈവ്', 'ചുണ്ടൻ'],
    },
  ],
};
